import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "./router";
import { AuthProvider } from "./auth-context";
import App from "./App";

createRoot(document.getElementById("root")).render(
  <RouterProvider>
    <AuthProvider>
      <App />
    </AuthProvider>
  </RouterProvider>
);
